<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return { }
  },
  methods: { }
}
</script>

<style lang="scss">
#app {
  // min-width: 1200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

//自定义nprogress颜色
#nprogress .bar {
  background: $color-yellow !important;
}

</style>

